/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from "react";
import "./poReports.styles.scss";
import { ReactComponent as CloseIcon } from "../../assets/cancel.svg";
import { ReactComponent as CheckedIcon } from "../../assets/checked.svg";

import { EyeOutlined, SyncOutlined } from "@ant-design/icons";

import dayjs from "dayjs";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { getBidReportsUrl } from "../../services/auction-services";

import {
  Table,
  message,
  Button,
  Spin,
  Progress,
  Alert,
  Flex,
  Space,
  Input,
  Tooltip,
} from "antd";

import CustomFilter from "../../components/custom-filter/custom-filter.component";
import {
  selectSelectedCrop,
  selectCrops,
  selectBranches,
  selectVarieties,
  selectCurrentPage,
  selectViewAuctionPage,
  selectSelectedBranch,
  selectHubs,
  selectedStartDate,
  selectedEndDate,
} from "../../redux/common/common.selectors";

import Axios from "axios";
import { Dispatch } from "redux";
import { selectUserData } from "../../redux/user/user.selectors";
import {
  dataConstants,
  deliveryStatusList,
  FeatureCodes,
  paymentStatusList,
  poStatusList,
} from "../../constants/data-constants";

import {
  setEndDate,
  setPoParams,
  setPoScreen,
  setSelectedBranch,
  setSelectedCrop,
  setStartDate,
} from "../../redux/common/common.actions";
import { canUserAccess } from "../../utils/utils";
import { useLocation } from "react-router";

const FileDownLoad = require("js-file-download");

const PoReports: React.FC = (props: any) => {
  const {
    branches,
    varietiesList,
    selectedCropId,
    userData,
    crops,
    currentpage,
    viewAuctionPage,
    selectedBranch,
    setSelectedBranchIndex,
    setSelectedCropIndex,
    hubs,
    globalSocketData,
    setPoScreens,
    setPoDetails,
    setStart,
    setEnd,
    startDate,
    endDate,
  } = props;
  const [selectedVariety, setSelectedVariety] = useState();
  // const [selectedDates, setSelectedDates] = useState([
  //   dayjs().format("YYYY-MM-DD"),
  //   dayjs().format("YYYY-MM-DD"),
  // ]);
  const [selectedHub, setSelectedHub] = useState();
  const [isTableVisible, setisTableVisible] = useState(true);
  const [poReportData, setPoReportData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isProgressClicked, setisProgressClicked] = useState(false);
  const [downloaddata, setdownloaddata] = useState<any>();
  const [isSpinnerOnProgress, setIsSpinnerOnProgress] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [vendor, setVendor] = useState("");
  const [poStatus, setPoStatus] = useState();
  const [delivery, setDelivery] = useState();
  const [payment, setPayment] = useState();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
    total: 0,
    showSizeChanger: false,
  });
  let poReportIntervalID = useRef<NodeJS.Timeout>();
  const location = useLocation();

  const columns = [
    {
      title: "PO Number",
      key: "PO_Number",
      dataIndex: "PO_Number",
    },
    {
      title: "PO Date",
      dataIndex: "Purchase_Order_Date",
      key: "Purchase_Order_Date",
    },
    {
      title: "PO Value (₹)",
      dataIndex: "Executed_PO_Amount",
      key: "Executed_PO_Amount",
    },
    {
      title: "Crop Name",
      dataIndex: "Crop_Name",
      key: "Crop_Name",
    },
    {
      title: "Variety",
      dataIndex: "Variety_Name",
      key: "Variety_Name",
    },
    {
      title: "Hub",
      dataIndex: "Hub_Name",
      key: "Hub_Name",
    },
    {
      title: "GRN Number",
      dataIndex: "GRN_ID",
      key: "GRN_ID",
    },
    {
      title: "GRN Date",
      dataIndex: "GRN_Date",
      key: "GRN_Date",
    },
    {
      title: "GRN Quantity",
      dataIndex: "GRN_Quantity",
      key: "GRN_Quantity",
    },
    {
      title: "Claim Type",
      dataIndex: "ClaimType",
      key: "ClaimType",
    },
    {
      title: "Vendor Code",
      dataIndex: "Vendor_code",
      key: "Vendor_code",
    },
    {
      title: "Vendor Name",
      dataIndex: "Vendor_Name",
      key: "Vendor_Name",
    },
    {
      title: "Broker Code",
      dataIndex: "Broker_code",
      key: "Broker_code",
    },
    {
      title: "Broker Name",
      dataIndex: "Broker_Name",
      key: "Broker_Name",
    },
    {
      title: "Delivery Status",
      dataIndex: "Delivery_Status",
      key: "Delivery_Status",
    },
    {
      title: "PO Status",
      dataIndex: "PO_Status",
      key: "PO_Status",
    },
    {
      title: "Payment Status",
      key: "Payment_Status",
      dataIndex: "Payment_Status",
    },
    {
      title: "Action",
      dataIndex: "",
      key: "action",
      render: (_, record) => (
        <Tooltip title="View Details">
          <Button
            type="text"
            icon={<EyeOutlined />}
            onClick={() => {
              setPoDetails({
                po_number: record.PO_Number,
                grn_id: record.GRN_ID,
                grn_quantity: record.GRN_Quantity,
                executed_po_amount: record.Executed_PO_Amount,
                total_amount: record.Total_Amount,
                quality_parameter: record.Quality_Parameter,
              });
              setPoScreens(true);
            }}
          />
        </Tooltip>
      ),
    },
  ];
  useEffect(() => {
    if (location.pathname.includes("/reports/auction") && globalSocketData) {
      poReportIntervalID?.current && clearInterval(poReportIntervalID?.current);
      // poReportDataSocketEmition();
    }
  }, [globalSocketData]);

  // const filterData = useMemo(() => {
  //   if (!searchText) return poReportData;

  //   return poReportData.filter((row) =>
  //     Object.values(row).some((value) =>
  //       String(value).toLowerCase().includes(searchText.toLowerCase()),
  //     ),
  //   );
  // }, [poReportData, searchText]);
  useEffect(() => {
    setSelectedVariety(undefined);
  }, [varietiesList]);
  const poReportDataSocketEmition = async (hubId?: any) => {
    // setIsLoading(true);
    setisTableVisible(true);
    const params = {
      start_date: startDate,
      end_date: endDate,
      crop_id: [selectedCropId],
      branch_id: [selectedBranch],
      hub_id: selectedHub,
      variety_id: selectedVariety,
      delivery_status: delivery && [delivery],
      po_status: poStatus && [poStatus],
      payment_status: payment && [payment],
      vendor_code: vendor,
      po_number: searchText,
      broker_code: vendor,
    };
    try {
      if (globalSocketData) {
        globalSocketData.emit("tm_to_offline_order_event", params);
        // setIsLoading(true);
        globalSocketData.on("my_orders", (data: any) => {
          setPoReportData(data);
          setIsLoading(false);
        });
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      message.warning("Something went wrong. Try agin ..!");
      setPoReportData([]);
    }
  };
  useEffect(() => {
    if (location.pathname.includes("/reports/po") && globalSocketData) {
      poReportIntervalID?.current && clearInterval(poReportIntervalID?.current);
      poReportDataSocketEmition();
      poReportIntervalID.current = setInterval(() => {
        poReportDataSocketEmition();
      }, 10000);
    }
    return () => {
      poReportIntervalID?.current && clearInterval(poReportIntervalID?.current);
    };
    // onBranchChange(selectedBranch, []);
  }, [
    currentpage,
    viewAuctionPage,
    selectedVariety,
    startDate,
    endDate,
    selectedBranch,
    selectedCropId,
    // pagination.current,
    globalSocketData,
    selectedHub,
    delivery,
    poStatus,
    payment,
    searchText,
    vendor,
  ]);
  const onDateChange = (value: string | number | any, timeString: any) => {
    setPagination((prev) => ({
      ...prev,
      current: 1,
    }));
    setStart(timeString[0]);
    setEnd(timeString[1]);

    // #region disable table view after several days
    /* let start = dayjs(timeString[0]);
    let end = dayjs(timeString[1]);
    let differenceInDays = end.diff(start, "days");

    if (differenceInDays > 14) {
      return setisTableVisible(false);
    } */
  };

  const fileDownload = async () => {
    setIsSpinnerOnProgress(true);
    const body = {
      start_date: startDate,
      end_date: endDate,
      crop_id: [selectedCropId],
      branch_id: [selectedBranch],
      hub_id: selectedHub,
      variety_id: selectedVariety,
      delivery_status: delivery && [delivery],
      po_status: poStatus && [poStatus],
      payment_status: payment && [payment],
      vendor_code: vendor,
      po_number: searchText,
      broker_code: vendor,
      // download: true,
    };
    // if (process.env.REACT_APP_ENV !== "production") {
    //   message.success(
    //     "Mail will send to your official email ID with the report.",
    //   );
    //   setIsSpinnerOnProgress(false);
    //   return false;
    // }
    //#region file download
    Axios({
      url: dataConstants.poReportsUrl,
      method: "POST",
      data: body,
      responseType: "blob",
      onDownloadProgress: (progressEvent: any) => {
        let progress = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setdownloaddata(progress);
      },
    })
      .then((response: any) => {
        FileDownLoad(
          response.data,
          `POwise_Report_${new Date().toLocaleDateString()}.xlsx`
        );
        message.success("File has been downloaded successfully!");
        setIsSpinnerOnProgress(false);
        setTimeout(
          function () {
            setisProgressClicked(false);
          }.bind(this),
          5000
        );
      })
      .catch((err: any) => {
        message.error("File cannot be downloaded");
        setIsSpinnerOnProgress(false);
        setisProgressClicked(false);
      });
    //#endregion
  };
  const onchange = (page) => {
    setPagination({
      current: page.current,
      pageSize: 20,
      total: 0, // total records from backend
      showSizeChanger: false,
    });
  };
  return (
    <Spin spinning={isSpinnerOnProgress} tip="Please wait...">
      <div className="po-report">
        <Flex gap={10} wrap>
          <Space wrap>
            <Input.Search
              placeholder="PO Number..."
              allowClear
              onSearch={setSearchText}
              onChange={(e) => {
                setIsSpinnerOnProgress(true);
                setSearchText(e.target.value);
                setTimeout(() => {
                  setIsSpinnerOnProgress(false);
                }, 500);
              }}
              style={{ width: "15em" }}
              variant="outlined"
            />
            <Input.Search
              placeholder="Vendor Code/Name..."
              allowClear
              onSearch={setVendor}
              onChange={(e) => setVendor(e.target.value)}
              style={{ width: "15em" }}
              variant="outlined"
            />
            <CustomFilter
              type="range-picker"
              head="Date Range"
              startDate={dayjs(startDate)}
              endDate={dayjs(endDate)}
              disabledDate={true}
              // disabledDate={[
              //   { startDate: dayjs().subtract(1, "year") },
              //   { endDate: dayjs().add(1, "days") },
              // ]}
              onChange={onDateChange}
            />
            <CustomFilter
              type="single-select"
              value={selectedCropId}
              options={crops}
              onChange={(value: any) => {
                setPagination((prev) => ({
                  ...prev,
                  current: 1,
                }));
                setSelectedCropIndex(value);
              }}
              placeholder="Select Branch"
              head="ITC Branch Office"
              returnId
            />
            <CustomFilter
              type="single-select"
              value={selectedBranch}
              options={branches}
              onChange={(value: any) => {
                setPagination((prev) => ({
                  ...prev,
                  current: 1,
                }));
                setSelectedHub(undefined);
                setSelectedBranchIndex(value);
              }}
              placeholder="Select Branch"
              head="ITC Branch Office"
              returnId
            />
            <CustomFilter
              // type="single-select"
              type="multi-select"
              value={selectedHub}
              options={hubs}
              onChange={(value: any) => {
                setPagination((prev) => ({
                  ...prev,
                  current: 1,
                }));
                setSelectedHub(value);
                poReportDataSocketEmition(value);
              }}
              placeholder="Select Hub"
              head="Hub"
              returnId
            />
            <CustomFilter
              // type="single-select"
              type="multi-select"
              value={selectedVariety}
              onChange={(value: any) => {
                setPagination((prev) => ({
                  ...prev,
                  current: 1,
                }));
                setSelectedVariety(value);
              }}
              options={varietiesList}
              placeholder="Select Variety"
              head="Variety"
              returnId
            />
            <CustomFilter
              type="single-select"
              value={payment}
              options={paymentStatusList}
              onChange={(value: any) => {
                setPagination((prev) => ({
                  ...prev,
                  current: 1,
                }));
                setPayment(value);
              }}
              allowClear={true}
              placeholder="Select Payment Status"
              head="Payment Status"
              returnId
            />
            <CustomFilter
              type="single-select"
              value={poStatus}
              options={poStatusList}
              onChange={(value: any) => {
                setPagination((prev) => ({
                  ...prev,
                  current: 1,
                }));
                setPoStatus(value);
              }}
              allowClear={true}
              placeholder="Select PO Status"
              head="PO Status"
              returnId
            />
            <CustomFilter
              type="single-select"
              value={delivery}
              options={deliveryStatusList}
              onChange={(value: any) => {
                setPagination((prev) => ({
                  ...prev,
                  current: 1,
                }));
                setDelivery(value);
              }}
              allowClear={true}
              placeholder="Delivery Status"
              head="Delivery Status"
              returnId
            />
            {poReportData?.length > 0 && (
              <Button
                onClick={() => {
                  setdownloaddata(0);
                  setisProgressClicked(true);
                  fileDownload();
                }}
                type="primary"
                // shape="round"
                // icon="download"
                // size="large"
                // style={{ display: "block" }}
                className="download-btn-styles"
                disabled={canUserAccess(
                  userData,
                  FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS
                )}
                loading={isProgressClicked}
              >
                Download
              </Button>
            )}
          </Space>
          {/* <Button
            className="refresh"
            icon={<SyncOutlined spin={isLoading} />}
            onClick={() => poReportDataSocketEmition()}
          >
            Refresh
          </Button> */}
        </Flex>
        {isTableVisible ? (
          <div className="auction-report-table-container">
            <Table
              loading={isLoading}
              columns={columns}
              // dataSource={bidReportData}
              dataSource={poReportData}
              pagination={pagination}
              onChange={onchange}
              size="small"
              // scroll={{ x: "max-content" }}
              // tableLayout="fixed"
            />
          </div>
        ) : (
          <Alert
            style={{ padding: "10px", width: "50%", margin: "auto" }}
            message="Informational Notes"
            description="The data for the selected time period is too big. You can use the button at the bottom right to download the file"
            type="info"
            showIcon
          />
        )}
      </div>
    </Spin>
  );
};
const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setSelectedBranchIndex: (index: number) =>
      dispatch(setSelectedBranch(index)),
    setSelectedCropIndex: (index: number) => dispatch(setSelectedCrop(index)),
    setPoScreens: (status: boolean) => dispatch(setPoScreen(status)),
    setPoDetails: (params: any) => dispatch(setPoParams(params)),
    setStart: (params: any) => dispatch(setStartDate(params)),
    setEnd: (params: any) => dispatch(setEndDate(params)),
  };
};
const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
  branches: selectBranches,
  crops: selectCrops,
  varietiesList: selectVarieties,
  selectedCropId: selectSelectedCrop,
  currentpage: selectCurrentPage,
  viewAuctionPage: selectViewAuctionPage,
  selectedBranch: selectSelectedBranch,
  startDate: selectedStartDate,
  endDate: selectedEndDate,
  hubs: selectHubs,
});

export default connect(mapStateToProps, mapDispatchToProps)(PoReports);
